<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="quickSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="filter.searchDate"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Jenis Fasilitas</label>
                  <a-select
                    placeholder="Jenis Fasilitas"
                    v-model="filter.jenis_fasilitas"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option value="FP">
                      Fasilitas Non KMK
                    </a-select-option>
                    <a-select-option value="FK">
                      Fasilitas KMK
                    </a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="filter.status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.label"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataListSlot
        title="Financing List"
        manifestLink="spclfinancingManifest"
        :disabledCreateEditLink="true"
        :fileStatus="true"
        :dataList="datasource"
      >
        <div slot="status" slot-scope="data">
          <status :status="data.item.closeStatus" />
        </div>
        <div
          class="m-display-flex flex-row space-between"
          slot="status_file"
          slot-scope="data"
        >
          <span class="margin-remove">Document</span>
          <a-tag
            :color="data.item.is_uploaded == '1' ? 'green' : ''"
            class="margin-remove"
          >
            {{
              data.item.is_uploaded == "0"
                ? "No File Uploaded"
                : "File Have Been Uploaded"
            }}
          </a-tag>
        </div>
      </DataListSlot>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "financing",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: false,
      rawData: [],
      filter: {
        searchDate: null,
        jenis_fasilitas: null,
        status: null,
      },
      quickSearch: "",
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getListFinancing",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getStatus",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.keyword &&
            obj.keyword.toLowerCase().indexOf(this.quickSearch.toLowerCase()) >=
              0
        );
      }

      if (this.filter.searchDate) {
        let filter = moment(this.filter.searchDate).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(outputData, (obj) => obj.financing_dt == filter);
      }

      if (this.filter.jenis_fasilitas) {
        outputData = _.filter(
          outputData,
          (obj) => obj.type == this.filter.jenis_fasilitas
        );
      }

      if (this.filter.status) {
        outputData = _.filter(
          outputData,
          (obj) => obj.status_besar == this.filter.status
        );
      }

      return outputData;
    },
  },
  mounted() {
    this.fetch();
    this.$store.commit("setInitialFinance");
  },
  methods: {
    moment,
    fetch() {
      this.$store
        .dispatch("getListFinancing", { auth: this.getAuth })
        .then((res) => {
          res.forEach((data) => {
            this.rawData.push({
              can_cancel: data.can_cancel,
              can_revisi: data.can_revisi,
              cancel_sts: data.cancel_sts,
              close_sts: data.close_sts,
              id: data.id_financing,
              title: data.no_trans_financing+" | "+data.tlc_create,
              keyword:
                data.no_trans_financing+" | "+data.tlc_create +
                " " +
                data.financing_no +
                " " +
                data.tlc_create +
                " " +
                data.financing_dt +
                " " +
                data.jml_fasilitas +
                " " +
                data.pemakaian +
                " " +
                data.balance +
                " " +
                (data.type_financing == "FP"
                  ? "Fasilitas Non KMK"
                  : "Fasilitas KMK"),
              subtitle:
                data.type_financing == "FP"
                  ? "Fasilitas Non KMK"
                  : "Fasilitas KMK",
              financing_dt: data.financing_dt,
              type: data.type_financing,
              status_besar: data.status,
              status: data.can_revisi == "1" ? "Revised" : "",
              subdesc: [
                data.financing_no,
                data.financing_dt,
                [
                  {
                    label: "Plafon",
                    value: this.formatCurrency("IDR", data.jml_fasilitas),
                  },
                  {
                    label: "Pemakaian",
                    value: this.formatCurrency("IDR", data.pemakaian),
                  },
                  data.type_financing == "FK"
                    ? {
                        label: "Balance",
                        value: this.formatCurrency("IDR", data.balance),
                      }
                    : {},
                ],
              ],
              timeline: JSON.parse(data.status_app),
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : data.cancel_sts == 2
                  ? "Unusual"
                  : null
                : null,
              closeStatus: data.close_sts == "1" ? "Close" : "",
              islistPPrevised:
                data.close_sts !== "1" &&
                data.cancel_sts !== 1 &&
                data.can_revisi == "1"
                  ? true
                  : false,
              is_uploaded: data.is_uploaded,
            });
          });
        });
    },
    handleRevise(item) {
      this.$router.push({
        name: "financing-edit",
        params: { id: item.id, type: "revisi" },
      });
    },
    handleAmandemen(item) {
      this.$router.push({
        name: "financing-edit",
        params: { id: item.id, type: "amandemen" },
      });
    },
  },
};
</script>

<style></style>
